import { doPatchFileUpload } from '../../helpers';

export const n43 = {
  uploadN43File: () => body => doPatchFileUpload<void>('/dashboard/n43/upload-n43-file', body)
};
